import { Audio } from "./audio"
import sensorLog from "@/utils/sensorLog"
import * as types from "@/constants"
export class AudioMixing {
  constructor() {
    this.audio = new Audio()
    this.context = null
    this.audioSource = null
    this.micSource = null
    this.micAudioTracks = null
    this.micGainNode = null
    this.dest = null
    this.currentGainValue = 1
  }

  /**
   * 开始混音
   * @param wrappedStream
   * @param filePath
   * @returns {Promise<{preFilePath, stream: *}>}
   */
  async startMixing({ filePath, finished, volume }) {
    if (!this.context) {
      this.context = new (window.AudioContext || window.webkitAudioContext)()
    }
    sensorLog.track(
      "start_mixing_context_status",
      types.SENSORLOG.type.INIT,
      JSON.stringify({ status: this.context.state })
    )
    const { preFilePath } = await this.audio.create(filePath, finished, volume)
    return { preFilePath, audio: this.audio.audio }
  }

  /**
   *
   * @param wrappedStream 现在已经发布的流
   * @returns {Promise<*>}
   */
  confluence(wrappedStream) {
    if (!this.context) {
      this.context = new (window.AudioContext || window.webkitAudioContext)()
    }
    sensorLog.track(
      "confluence_context_status",
      types.SENSORLOG.type.INIT,
      JSON.stringify({ status: this.context.state })
    )

    const context = this.context
    const dest = (this.dest = this.context.createMediaStreamDestination()) // 创建音频处理中间节点
    if (wrappedStream) {
      this.micAudioTracks = wrappedStream.stream.getAudioTracks()[0]
      console.log("=========wrappedStream.audio=======", wrappedStream.audio)
      console.log("=========this.micAudioTracks=======", this.micAudioTracks)
      if (wrappedStream.audio) {
        console.log("media mixed createMediaStreamSource success=====")
        this.micSource = context.createMediaStreamSource(wrappedStream.stream) // 获取声网流中的音频资源
        this.micGainNode = context.createGain()
        this.micSource.connect(this.micGainNode)
        this.micGainNode.connect(dest) // 将声网流中的音频资源链接到中间节点
        this.micGainNode.gain.value = this.currentGainValue
        console.log(
          "media mixed createMediaStreamSource micGainNode=====",
          this.micGainNode.gain.value
        )
      }
      if (this.micAudioTracks) {
        console.log("wrapped mixed getAudioTrack=====", this.micAudioTracks)
        wrappedStream.stream.removeTrack(this.micAudioTracks)
        console.log(
          "wrapped mixed removeTrack=====",
          wrappedStream.stream.getAudioTracks()[0]
        )
        wrappedStream.stream.addTrack(dest.stream.getAudioTracks()[0])
        console.log(
          "wrapped mixed addTrack=====",
          wrappedStream.stream.getAudioTracks()[0]
        )
        // wrappedStream.replaceTrack(dest.stream.getAudioTracks()[0])
        // console.log("wrapped replaceTrack=====", wrappedStream.getAudioTrack())
      } else if (wrappedStream.stream.getVideoTracks()[0]) {
        return Object.assign(wrappedStream, {
          stream: dest.stream
        })
      }
    } else {
      wrappedStream = {
        stream: dest.stream
      }
    }
    return wrappedStream
  }

  /**
   *
   * @param audio 需要进行混音的音频源节点
   * @param isConnectMediaElement 是否重新连接音视频节点
   */
  connectMediaElementToDest(audio, isConnectMediaElement) {
    if (audio) {
      if (!this.audioSource || isConnectMediaElement) {
        this.audioSource = this.context.createMediaElementSource(audio)
        console.log(
          "media mixed createMediaElementSource success=====",
          this.audioSource
        )
      }
      this.audioGainNode = this.context.createGain()
      this.audioSource.connect(this.audioGainNode)
      this.audioGainNode.connect(this.context.destination) // 播放源媒体音轨
      this.audioGainNode.connect(this.dest)
      this.audioGainNode.gain.value = 1
    }
  }

  disconnectMediaElementFromDest() {
    this.audioSource && this.audioSource.disconnect()
    this.audioGainNode && this.audioGainNode.disconnect()
  }

  setMicroVolume(volume) {
    let equivalentValue = 100
    if (!this.micSource) return
    if (this.micGainNode && this.micGainNode.gain) {
      this.currentGainValue = this.micGainNode.gain.value =
        volume / equivalentValue
      console.log(
        "666666666666666666666media mixed setMicroVolume micGainNode=====",
        this.micGainNode.gain.value
      )
    }
  }

  resumeDefaultVolume() {
    if (this.micGainNode && this.micGainNode.gain) {
      this.currentGainValue = this.micGainNode.gain.value = 1
      console.log(
        "media mixed resume micGainNode=====",
        this.micGainNode.gain.value
      )
    }
  }

  /**
   * 暂停混音
   * @returns {Promise<*>}
   */
  pauseMixing() {
    return this.audio.pause()
  }

  /**
   * 恢复混音
   * @param filePath
   * @returns {Promise<*>}
   */
  resumeMixing(filePath) {
    return this.audio.play(filePath)
  }

  /**
   * 停止混音
   */
  stopMixing() {
    return this.audio.stop()
  }

  deleteAudio() {
    return this.audio.delete()
  }

  /**
   * 设置混音音量
   * @param volume
   * @returns {Promise<string|void>}
   */
  setMixingVolume(volume) {
    return this.audio.setVolume(volume)
  }

  /**
   * 更新播放进度
   * @param filePath
   * @param period
   * @param process
   */
  updateProcess(filePath, period, process) {
    return this.audio.updateProcess(filePath, period, process)
  }
}
